import { getPageConfigs } from 'utils/marketExtensionConfig';

const getPageConfig = (route: string) => {
  const pageConfigData = getPageConfigs()?.pageConfigs || {};
  return pageConfigData[route] || {};
};

export default getPageConfig;
